import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Admin = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("isAdminLoggedIn");
        navigate("/login");
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                backgroundColor: "#f5f1eb",
                padding: {
                    xs: "30px 20px",
                    md: "50px",
                },
            }}
        >
            <Box
                sx={{
                    maxWidth: "1200px",
                    margin: "0 auto",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 5,
                    }}
                >
                    <Box>
                        <Typography
                            sx={{
                                fontFamily: "'Poppins', sans-serif",
                                fontSize: "1.8rem",
                                fontWeight: 600,
                            }}
                        >
                            Admin Dashboard
                        </Typography>

                        <Typography
                            sx={{
                                color: "#888",
                                fontSize: "0.9rem",
                            }}
                        >
                            Welcome back, admin.
                        </Typography>
                    </Box>

                    <Button
                        onClick={handleLogout}
                        sx={{
                            color: "#555",
                            textTransform: "none",
                        }}
                    >
                        Logout
                    </Button>
                </Box>

                {/* Dashboard Cards */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "repeat(2, 1fr)",
                            md: "repeat(3, 1fr)",
                        },
                        gap: 3,
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            padding: 4,
                            boxShadow: "0 5px 20px rgba(0,0,0,0.05)",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: "1.1rem",
                                fontWeight: 600,
                                marginBottom: 1,
                            }}
                        >
                            Products
                        </Typography>

                        <Typography
                            sx={{
                                color: "#888",
                                fontSize: "0.9rem",
                            }}
                        >
                            Manage your shop products
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            padding: 4,
                            boxShadow: "0 5px 20px rgba(0,0,0,0.05)",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: "1.1rem",
                                fontWeight: 600,
                                marginBottom: 1,
                            }}
                        >
                            Gallery
                        </Typography>

                        <Typography
                            sx={{
                                color: "#888",
                                fontSize: "0.9rem",
                            }}
                        >
                            Manage gallery images
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            padding: 4,
                            boxShadow: "0 5px 20px rgba(0,0,0,0.05)",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: "1.1rem",
                                fontWeight: 600,
                                marginBottom: 1,
                            }}
                        >
                            Stock
                        </Typography>

                        <Typography
                            sx={{
                                color: "#888",
                                fontSize: "0.9rem",
                            }}
                        >
                            Manage product stock
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default Admin;